export default "__VITE_ASSET__Dy2UpM3n__"